"use client";

import { signIn } from "next-auth/react";
import { useSearchParams } from "next/navigation";
import { useEffect } from "react";

export function SignInContent() {
  const searchParams = useSearchParams();
  const error = searchParams.get("error");
  const callbackUrl = searchParams.get("callbackUrl") ?? "/";

  useEffect(() => {
    if (!error) {
      signIn("keycloak", { callbackUrl });
    }
  }, []);

  if (error) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <div className="text-center space-y-4 max-w-sm px-4">
          <h1 className="text-xl font-semibold">Anmeldung fehlgeschlagen</h1>
          <p className="text-sm text-muted-foreground">
            Die Verbindung zu Keycloak ist fehlgeschlagen. Bitte versuchen Sie
            es erneut.
          </p>
          <button
            onClick={() => signIn("keycloak", { callbackUrl })}
            className="inline-flex items-center justify-center rounded-md bg-primary px-4 py-2 text-sm font-medium text-primary-foreground hover:bg-primary/90"
          >
            Erneut anmelden
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center">
      <p className="text-sm text-muted-foreground">Weiterleitung zu Keycloak…</p>
    </div>
  );
}
